<div class="h-full pt-4">
  <pl-edit-lifemap-entry
    [allActivities]="allActivities()"
    [blockLifemap]="blockLifemap()"
    [event]="event()"
    [timeFormat]="timeFormat()"
    (discardButtonClicked)="discardChangesOnEditEvent()"
    (saveButtonClicked)="saveLifeMapEntry($event)"
  />
</div>
